import React, { Component } from 'react';
import { connect } from 'react-redux';
import UserReviews from 'components/UserReviews';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import DeliveryAreas from 'components/DeliveryAreas';
import Ratings from '../../components/Ratings';
import { setState } from 'containers/Home/actions';
import { selectStoreConfig } from '../../containers/Layout/selectors';
import { selectIsEnabledGoogleReview } from '../../containers/Home/selectors';
import Map from 'components/Map';

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEnterAnimation: true,
      showAnimation: false,
    };
  }

  componentDidMount() {
    this.mounted = true;

    if (this.state.showEnterAnimation) {
      if (this.mounted) {
        setTimeout(() => {
          this.setState({ showEnterAnimation: false });
        }, 1000);
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  closeAfterAnimation = () => {
    this.setState({ showAnimation: true });
    this.props.setState({ aboutOpen: false });
  };

  render() {
    const { storeConfig, isEnableGoogleReview, aboutOpen } = this.props;

    const transitionStyles = {
      entering: { transform: `translateY(0)` },
      entered: { transform: `translateY(-100%)` },
      exiting: { transform: `translateY(0)` },
      exited: { transform: `translateY(0)`, display: `none` },
    };

    return (
      <>
        <DeliveryAreas
          close={() => this.setState({ deliveryAreasOpen: false })}
          open={this.state.deliveryAreasOpen}
        />

        <Transition in={aboutOpen} timeout={250}>
          {(state) => (
            <div
              className='aboutWrap'
              style={{
                zIndex: 9999,
                position: `absolute`,
                width: `100%`,
                bottom: 0,
                left: 0,
                transition: `transform .25s ease-out`,
                ...transitionStyles[state],
              }}
            >
              <div
                className='visible-xs visible-sm close-x thickcon-X'
                onClick={() => this.props.setState({ aboutOpen: false })}
              />
              <div className='aboutTitleWrap'>
                <div className='leftSecA'>
                  <div className='titleA'>{storeConfig.name}</div>
                  <div className='subTitleA'>{storeConfig.type}</div>
                </div>
                <div className='rightSecA'>
                  {this.props.reviewStats?.averageRating && (
                    <Ratings
                      rating={
                        this.props.reviewStats.averageRating
                          ? Number(
                              this.props.reviewStats.averageRating
                            ).toFixed(1)
                          : 0
                      }
                    />
                  )}
                </div>
              </div>
              <div className='about1'>
                <div className='aboutContent'>
                  {aboutOpen && storeConfig?.addressLocation && (
                    <div className='mapContainer'>
                      <Map
                        lat={storeConfig.addressLocation.lat}
                        long={storeConfig.addressLocation.long}
                      />
                    </div>
                  )}
                  <ul>
                    <li>{storeConfig.address}</li>
                    {storeConfig.phoneNumberDisplay ||
                    storeConfig.emailAddress ? (
                      <li onClick={this.props.recordPhoneClickHandler}>
                        {storeConfig.phoneNumberDisplay ||
                          storeConfig.emailAddress}
                        <a
                          href={
                            storeConfig.phoneNumberDisplay
                              ? `tel:${storeConfig.phoneNumber}`
                              : `mailto:${storeConfig.emailAddress}`
                          }
                          title='Contact restaurant'
                        >
                          {storeConfig.phoneNumberDisplay ? 'Call' : 'Mail'}
                        </a>
                      </li>
                    ) : null}
                    {this.props.currentShift && (
                      <li
                        onClick={() => {
                          this.props.openIt();
                        }}
                      >
                        <strong>
                          {this.props.currentShift &&
                          this.props.currentShift.isPickupOpen
                            ? 'Open'
                            : 'Closed'}
                        </strong>
                        <i className='thickcon-Right-Chevron' />
                      </li>
                    )}
                    {this.props.isDeliveryOn === true &&
                      this.props?.allSuburbs?.length > 0 && (
                        <li
                          onClick={() => {
                            this.setState({
                              deliveryAreasOpen: true,
                            });
                          }}
                        >
                          Delivery Areas
                          <i className='thickcon-Right-Chevron' />
                        </li>
                      )}
                    {!isEnableGoogleReview ? (
                      <>
                        <li
                          onClick={() => {
                            this.setState({
                              reviewOpen: true,
                            });
                          }}
                        >
                          {this.props.reviewStats &&
                          this.props.reviewStats.totalReviews
                            ? `${this.props.reviewStats.totalReviews} `
                            : `0 `}
                          Reviews <i className='thickcon-Right-Chevron' />
                        </li>
                        <UserReviews
                          open={this.state.reviewOpen}
                          close={() => this.setState({ reviewOpen: false })}
                          review={this.props.review}
                          closeReview={this.props.closeReview}
                          reviewStats={this.props.reviewStats}
                          reviewStatsByRating={this.props.reviewStatsByRating}
                          ref={(c) => {
                            this.reviewPop = c;
                          }}
                          storeConfig={this.props.storeConfig}
                        />
                      </>
                    ) : null}
                    {this.props.currentUser &&
                      this.props.currentUser.phoneNumber &&
                      this.props.userDetails &&
                      this.props.userDetails.firstName && (
                        <li
                          onClick={() => {
                            this.props.signOut();
                          }}
                        >
                          Logout
                        </li>
                      )}
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Transition>
      </>
    );
  }
}

About.propTypes = {
  reviewStats: PropTypes.any,
  currentShift: PropTypes.any,
  recordPhoneClickHandler: PropTypes.any,
};

function mapStateToProps(state) {
  return {
    isEnableGoogleReview: selectIsEnabledGoogleReview(state),
    storeConfig: selectStoreConfig(state),
    aboutOpen: state.homeReducer.aboutOpen,
    allSuburbs: state.orderReducer.allSuburbs,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setState: (payload) => dispatch(setState(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(About);
